import {Component} from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import {FormattedMessage} from "react-intl";
import GlobalMessages from "messages/messages";
import FormattedDate, {DATE_FORMATS,} from "basicComponents/FormattedDate/Formatted";
import ConfirmModal from "basicComponents/ConfirmModal/ConfirmModal";
import messages from "./messages";
import Edit from "../../images/EditIcon";
import Delete from "../../images/DeleteIcon";
import {styling} from "styling";
import {hasRole, ROLES} from "../../utils/userStorage";
import InfoModal from "../../basicComponents/InfoModal/InfoModal";
import RefrezhButton from "components/RefrezhButton";

export default class TreatmentRow extends Component {
  static propTypes = {
    treatment: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    noDivider: PropTypes.bool,
    active: PropTypes.bool,
    noSkip: PropTypes.bool,
    past: PropTypes.bool,
    tooSoon: PropTypes.bool,
    showPrevious: PropTypes.bool,
    wagnerButton: PropTypes.bool,
    onSkip: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onPrevious: PropTypes.func.isRequired,
    onExtraTreatment: PropTypes.func.isRequired,
    wagnerActive: PropTypes.bool,
    screenWidth: PropTypes.bool,
    adminOnly: PropTypes.bool,
  };
  static defaultProps = {
    screenWidth: styling.breakpointNumbers.desktopLargeUp,
  };

  state = {
    deleteModalOpen: false,
    extraTreatmentModalOpen: false,
    tooSoonModalOpen: false,
  };

  handlePrevious = () => {
    this.props.onPrevious(this.props.treatment, this.props.index);
  };

  handleSkip = () => {
    this.props.onSkip(this.props.treatment, this.props.index);
  };

  handleEdit = () => {
    let edit = true;
    if (this.props.adminOnly) {
      edit = hasRole([ROLES.KPT, ROLES.CS, ROLES.Admin]);
    }

    if (edit) {
      this.props.onEdit(this.props.treatment, this.props.index);
    } else {
      this.handleTooSoon();
    }
  };

  handleDelete = () => {
    let doDelete = true;
    if (this.props.adminOnly) {
      doDelete = hasRole([ROLES.KPT, ROLES.CS, ROLES.Admin]);
    }

    if (doDelete) {
      this.setState({
        deleteModalOpen: true,
      });
    } else {
      this.handleTooSoon();
    }
  };

  handleExtraTreatment = () => {
    this.setState({ extraTreatmentModalOpen: true });
  };

  handleCloseExtraTreatmentCancelModal = () => {
    this.setState({ extraTreatmentModalOpen: false });
  };

  handleConfirmExtraTreatment = () => {
    this.props.onExtraTreatment();
    this.handleCloseExtraTreatmentCancelModal();
  };

  handleConfirmCancel = () => {
    this.props.onDelete(this.props.treatment, this.props.index, null);
    this.handleCloseDeleteModal();
  };

  handleTooSoon = () => {
    this.setState({ tooSoonModalOpen: true });
  };

  handleTooSoonCancelModal = () => {
    this.setState({ tooSoonModalOpen: false });
  };

  handleCloseDeleteModal = () => {
    this.setState({
      deleteModalOpen: false,
    });
  };

  /**
   * Determine what should and shouldn't be shown.
   */
  show(what) {
    const { treatment } = this.props;
    switch (what) {
      case "skip":
        return !treatment.planned && !treatment.skipped && !this.props.noSkip;
      case "delete":
        return treatment.planned;
      case "tooSoonWarning":
        return treatment.planned && !this.props.past && this.props.tooSoon;
      case "next":
        return !this.show("skip") && !this.props.noSkip;
      case "edit": {
        return treatment.planned;
      }
      case "empty": {
        return (
          !this.show("previous") && !this.props.tooSoon && !this.props.noSkip
        );
      }
      case "extra": {
        return (
          treatment.planned &&
          !this.props.past &&
          !this.props.tooSoon &&
          treatment.active
        );
      }
      case "previous":
        return this.props.showPrevious;
      default:
        return true;
    }
  }

  renderButtonRow() {
    // have to add whole table to get rid of error mgs Validating dom td..
    return (
      <td>
        <table>
          <tbody>
            <tr>
              {this.show("edit") && (
                <EditIcon
                  onClick={this.handleEdit}
                  style={{ padding: "0" }}
                  id="editTreatment"
                >
                  <Edit />
                </EditIcon>
              )}
              {this.show("delete") && (
                <DeleteIcon
                  onClick={this.handleDelete}
                  style={{ padding: "0", paddingLeft: "10px" }}
                  id="deleteTreatment"
                >
                  <Delete />
                </DeleteIcon>
              )}
              {<></>}
            </tr>
          </tbody>
        </table>
      </td>
    );
  }

  renderTextButtonRows() {
    return (
      <SubRow>
        {this.show("tooSoonWarning") && (
          <Message
            colSpan={this.props.screenWidth ? 2 : 5}
            onClick={this.handleTooSoon}
          >
            <FormattedMessage {...messages.tooSoonToEdit} />
          </Message>
        )}
        {this.show("previous") && (
          <Message
            colSpan={5}
            onClick={this.handlePrevious}
            id="previousTreatment"
          >
            <FormattedMessage {...messages.previous} />
            <span className="prevbtn" dataid={this.props.treatment.id}>prev</span>
          </Message>
        )}
        {this.show("empty") && (
          <Message
            colSpan={this.props.screenWidth ? 2 : 5}
            id="emptyTreatment"
          />
        )}
        {this.show("skip") && (
          <Message colSpan="2" onClick={this.handleSkip} id="skipTreatment">
            <FormattedMessage {...messages.skipTreatment} />
            <span className="skipbtn" dataid={this.props.treatment.id}>skip</span>
          </Message>
        )}
        {this.show("next") && (
          <Message onClick={this.handleSkip} id="nextTreatment">
            <FormattedMessage {...GlobalMessages.next} />
            <span className="skipbtn" dataid={this.props.treatment.id}>skip</span>
          </Message>
        )}
      </SubRow>
    );
  }

  renderTooSoonModal() {
    return (
      <InfoModal
        open={this.state.tooSoonModalOpen}
        onConfirm={this.handleTooSoonCancelModal}
        header={<FormattedMessage {...GlobalMessages.tooSoonPopUpHeader} />}
      >
        <ModalSizeWidget>
          <FormattedMessage {...messages.tooSoonPopUp} />
        </ModalSizeWidget>
      </InfoModal>
    );
  }

  renderExtraTreatmentModal() {
    return (
      <ConfirmModal
        open={this.state.extraTreatmentModalOpen}
        onConfirm={this.handleConfirmExtraTreatment}
        onCancel={this.handleCloseExtraTreatmentCancelModal}
      >
        <ModalSizeWidget>
          <FormattedMessage {...messages.extraTreatmentConfirmation} />
        </ModalSizeWidget>
      </ConfirmModal>
    );
  }

  renderDeleteModal() {
    return (
      <ConfirmModal
        open={this.state.deleteModalOpen}
        onConfirm={this.handleConfirmCancel}
        onCancel={this.handleCloseDeleteModal}
      >
        <FormattedMessage {...messages.cancelConfirmation} />
      </ConfirmModal>
    );
  }

  // Main render view on pc
  render() {
    const { treatment } = this.props;
    const disabled = !this.props.active;
    const wagnerButton = this.props.wagnerButton;
    const firstItem = this.props.index === 0;
    const wagnerActive = this.props.wagnerActive;
    let rendered = null;
    if (this.props.screenWidth) {
      rendered = this.renderMobile();
    } else {
      rendered = (
        <>
          <Row disabled={disabled} key={treatment.id}>
            <TdMinimum>
              {this.props.index + 1}. {treatment.message}
              <span paultag="rowinfo" isdisabled={disabled ? "true" : "false"}>{treatment.id}</span>
            </TdMinimum>
            <TdMinimum>{treatment.duration} min</TdMinimum>
            <TdMinimum>
              {treatment.planned ? (
                <>
                  <FormattedDate
                    date={treatment.planned_date_time_from}
                    inputFormat={DATE_FORMATS.BUMBAL}
                    format={DATE_FORMATS.HUMAN_READABLE_FULL}
                  />
                  <FormattedMessage {...GlobalMessages.hoursSmall} />
                </>
              ) : (
                <FormattedMessage {...GlobalMessages.notYetPlanned} />
              )}
            </TdMinimum>
            {(!disabled && this.renderButtonRow()) || <td />}
            <TdMinimum data-cy="upperMessage">
              {treatment.upperProductMessage}
            </TdMinimum>
            <TdMinimum data-cy="lowerMessage">
              {treatment.lowerProductMessage}
            </TdMinimum>
          </Row>
          {!disabled && this.renderTextButtonRows()}

          <Row />

          {wagnerButton && !wagnerActive ? (
            <tr>
              <td colSpan="6">
                <Divider hide={this.props.noDivider} />
              </td>
            </tr>
          ) : null}
          {firstItem && wagnerButton && !this.props.wagnerActive ? (
            <Row>
              <ExtraTreatmentItem
                colSpan="2"
                style={{ paddingLeft: "1rem" }}
                onClick={this.handleExtraTreatment}
                id="extraTreatment"
              >
                <FormattedMessage {...messages.extraTreatment} />
                <span className="extratreatmentbtn">test</span>
              </ExtraTreatmentItem>
              <td colSpan="4" />
            </Row>
          ) : null}
          <tr>
            <td colSpan="6">
              <Divider hide={this.props.noDivider} />
            </td>
          </tr>
        </>
      );
    }

    return (
      <>
        {this.renderTooSoonModal()}
        {this.renderExtraTreatmentModal()}
        {this.renderDeleteModal()}
        {rendered}
      </>
    );
  }

  // this is done because of the table not being dynamic when resized
  renderMobile() {
    const { treatment } = this.props;
    const disabled = !this.props.active;
    const wagnerButton = this.props.wagnerButton;
    const firstItem = this.props.index === 0;
    const wagnerActive = this.props.wagnerActive;
    return (
      <>
        <Row>
          <TdHeader>
            
            <FormattedMessage {...messages.treatment} />
          </TdHeader>
          <TdHeader>
            <FormattedMessage {...messages.duration} />
          </TdHeader>
          <TdHeader>
            <FormattedMessage {...messages.plannedDate} />
          </TdHeader>
        </Row>
        <Row disabled={disabled} key={treatment.id}>
          <TdMinimum>
            {this.props.index + 1}. {treatment.message}
            <span paultag="rowinfo" isdisabled={disabled ? "true" : "false"}>{treatment.id}</span>
          </TdMinimum>
          <TdMinimum>{treatment.duration} min</TdMinimum>
          <TdMinimum>
            {treatment.planned ? (
              <>
                <FormattedDate
                  date={treatment.planned_date_time_from}
                  inputFormat={DATE_FORMATS.BUMBAL}
                  format={DATE_FORMATS.HUMAN_READABLE_FULL}
                />
                <FormattedMessage {...GlobalMessages.hoursSmall} />
              </>
            ) : (
              <FormattedMessage {...GlobalMessages.notYetPlanned} />
            )}
          </TdMinimum>
        </Row>
        <Row>
          <TdHeader />
          <TdHeader>
            <FormattedMessage {...messages.productUpperJaw} />
          </TdHeader>
          <TdHeader>
            <FormattedMessage {...messages.productLowerJaw} />
          </TdHeader>
        </Row>
        <Row>
          {(!disabled && this.renderButtonRow()) || <td />}
          <TdMinimum>{treatment.upperProductMessage}</TdMinimum>
          <TdMinimum>{treatment.upperProductMessage}</TdMinimum>
        </Row>
        {!disabled && this.renderTextButtonRows()}
        <Row />
        {wagnerButton && !wagnerActive ? (
          <tr>
            <td colSpan="5">
              <Divider hide={this.props.noDivider} />
            </td>
          </tr>
        ) : null}
        {firstItem && wagnerButton && !this.props.wagnerActive ? (
          <Row>
            <ExtraTreatmentItem
              colSpan={3}
              style={{ paddingLeft: "1rem" }}
              onClick={this.handleExtraTreatment}
              id="extraTreatment"
            >
              <FormattedMessage {...messages.extraTreatment} />
            </ExtraTreatmentItem>
            <td colSpan="1" />
          </Row>
        ) : null}
        <tr>
          <td colSpan="5">
            <Divider hide={this.props.noDivider} />
          </td>
        </tr>
      </>
    );
  }
}

const DeleteIcon = styled.td``;
const EditIcon = styled.td``;
const Message = styled.td`
  font-size: 13px;
  color: ${({ disabled, theme }) => (disabled ? theme.disabledColor : "black")};
`;

const ExtraTreatmentItem = styled.td`
  font-size: small;
  font-weight: bold;
  color: ${({ disabled, theme }) => (disabled ? theme.disabledColor : "black")};
  text-decoration: underline;
  cursor: pointer;
`;

const Content = styled.div`
  width: 50%;
  padding-bottom: ${({ theme }) => theme.padding}rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const MobileContent = styled.div`
  width: 100%;
  outline: none !important;
  padding: ${({ theme }) => theme.padding}rem;
  position: relative;
`;

const ModalSizeWidget = styled.div`
  width: 40rem;
`;

const Row = styled.tr`
  color: ${({ disabled, theme }) => (disabled ? theme.disabledColor : "black")};
  td {
    padding: ${({ theme }) => theme.padding}rem;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const ButtonColumn = styled.div`
  &:first-child {
    margin-right: ${({ theme }) => theme.margin}rem;
  }
`;

const SubRow = styled.tr`
  padding-top: 1rem;
  color: ${({ disabled, theme }) => (disabled ? theme.disabledColor : "black")};

  td {
    padding: ${({ theme }) => theme.padding}rem;
    padding-bottom: 0;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const TdMinimum = styled.td`
  ${({ flex }) => flex && `display: flex;`};
  ${({ theme }) => theme.tabletPortraitUp`
    min-width: 6.5rem;
  `};
`;

const TdHeader = styled(TdMinimum)`
  font-weight: bold;
`;

const Divider = styled.div`
  margin: ${({ theme }) => theme.padding}rem;
  padding-top: 0;
  ${({ hide, theme }) =>
    !hide && `border-bottom: 1px solid ${theme.borderColor};`};
`;
